import { h, Component, Prop } from '@stencil/core';


@Component({
  tag: 'tip-style'
})
export class Style {
  baseJson : any = {};
  layers: string[] = [];
  @Prop() tipIds: number[] = [];
  @Prop() layerNames: string;
  @Prop() url: string;


  async componentWillLoad() {
    let res = await fetch(this.url);
    this.baseJson = await res.json();
    this.layers = this.getLayerNames();
  }

  getLayerNames() {
    return this.baseJson.layers
      .map((layer : {id: string}) => layer.id)
      .filter((id : string) => {
        for (let base of this.layerNames.split(','))
          if (id.substring(0, base.length) === base) return true;
        return false;
      });
  }

  getJson() {
    return {
      ...this.baseJson,
      layers: this.baseJson.layers.map((layer) => {
        if (this.layers.indexOf(layer.id) === -1) return layer;
        if (this.tipIds.length === 0) return {
          ...layer,
          layout: {
            ...(layer.layout || {}),
            visibility: 'none'
          }
        };
        let idFilter = ['match', ['get', 'tip_id'], this.tipIds, true, false];
        return {
          ...layer,
          filter: (layer.filter) ? ['all', layer.filter, idFilter] : idFilter
        };
      })
    };
  }

  render() {
    return(
      <gl-style id="tip"
          json={this.getJson()}
          clickableLayers={this.layers}>
        <gl-popup component='gl-attribute-values'
          componentOptions={
            {
              headerAttribute: 'project_title',
              attributeOptions: [
                {
                  alias: 'Project ID',
                  name: 'project_id'
                },
                {
                  alias: 'Lead Agency',
                  name: 'lead_agency'
                },
                {
                  alias: 'Project Category',
                  name: 'project_category'
                },
                {
                  alias: 'Total Cost',
                  name: 'total_cost'
                }
              ]
            }
          }
          layers={this.layers}></gl-popup>
      </gl-style>
    )
  }
}
